import { render } from "./CustomerSpendSpendLabels.vue?vue&type=template&id=17e0a06d&scoped=true"
import script from "./CustomerSpendSpendLabels.vue?vue&type=script&lang=js"
export * from "./CustomerSpendSpendLabels.vue?vue&type=script&lang=js"

import "./CustomerSpendSpendLabels.vue?vue&type=style&index=0&id=17e0a06d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17e0a06d"],['__file',"src/components/CustomerSpendSpendLabels.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "17e0a06d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('17e0a06d', __exports__)) {
    api.reload('17e0a06d', __exports__)
  }
  
  module.hot.accept("./CustomerSpendSpendLabels.vue?vue&type=template&id=17e0a06d&scoped=true", () => {
    api.rerender('17e0a06d', render)
  })

}


export default __exports__